import $ from 'jquery';
import thdcustomer from 'thd-customer';
let order = {};

let removeB2XFooterLinks = function _removeB2XFooterLinks() {
  if(thdcustomer.isB2XCustomer){
    $('#B2CCheckOrder')
          .remove()
    $('#B2XCheckOrder')
          .removeClass('u--hide')
  }
  else{
    $('#B2XCheckOrder')
          .remove()
  }
};

order.init = function() {
  removeB2XFooterLinks();
};

export default order;